var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rights-page"},[_c('p',{staticClass:"rights-page_title"},[_c('van-icon',{attrs:{"name":"checked"}})],1),_c('h2',[_vm._v("建档登记成功")])])
}
var staticRenderFns = []

export { render, staticRenderFns }